import { Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { showError } from 'constants/errorMessages';
import { getToaster } from 'store/selectors';
import { closeToaster } from 'store/actions/toaster';
import Toaster from 'components/toaster';

const Toasters = () => {
  const dispatch = useDispatch();
  const toastersState = useSelector(getToaster);

  return Object.entries(toastersState).map(
    ([name, { type = 'error', key, content, params = [] }]) => {
      return (
        <Suspense key={name} fallback="">
          <Toaster isOpen>
            <div className="toaster-item">
              <div className="t-closed-holder">
                <i className="icon-closed" onClick={() => dispatch(closeToaster(name))} />
              </div>
              <p className="toaster-info">
                <i
                  className={classNames({
                    'error icon-alert-circle': type === 'error',
                    'success icon-check-circle': type === 'success',
                  })}
                />
                <span>
                  {type !== 'error' ? content : showError(key, ...params) || key}
                </span>
              </p>
            </div>
          </Toaster>
        </Suspense>
      );
    },
  );
};

export default Toasters;
